<template>
    <div class="app-container">
        <el-row class="navigation">
            <el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/xwqyczfw/rzfw' }">融资服务</el-breadcrumb-item>
				</el-breadcrumb>
            </el-col>
        </el-row>

        <el-row class="content">
			<el-row class="box-title">
				<span>申请信息</span>
				<el-divider></el-divider>
			</el-row>
			<div class="form-div">
				<el-form ref="form" :model="form" :rules="rules" label-width="250px" label-position="right">
					<el-row class="form-box-title">
						<div class="form-box-title-img">
							<img src="@/assets/images/xwqyczfw/rzfw/sq.png" />
						</div>
						<div class="form-box-flex">
							申请人基本信息
						</div>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="申请人名称:" prop="entname">
								<span>{{form.entname}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="统一社会信用代码:" prop="uniscid">
								<span>{{form.uniscid}}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="法定代表人:" prop="lerep">
								<el-input v-model="form.lerep" clearable placeholder="请输入法定代表人" disabled/>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="客户行业类型:" prop="khhylx">
								<el-select v-model="form.khhylx" size="medium" clearable class="input-width" disabled>
								  <el-option
								    v-for="item in khhylxOptions"
								    :key="item.dictValue"
								    :label="item.dictLabel"
								    :value="item.dictValue">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="经营地址:" prop="dom">
								<el-input v-model="form.dom" clearable placeholder="请输入经营地址" disabled/>
							</el-form-item>
						</el-col>
						<el-col :span="11" >
							<el-form-item label="注册资本:" prop="regist">
								<el-input v-model="form.regist" type="number" clearable class="input-width" placeholder="请输入注册资本" disabled/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="主营业务范围:" prop="busscope">
								<el-input v-model="form.busscope" placeholder="请输入主营业务范围" disabled/>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="持续经营年限:" prop="operatYear">
								<el-input v-model="form.operatYear" placeholder="请输入持续经营年限" />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="联系人及职务:" prop="contactOffice">
								<el-input v-model="form.contactOffice" placeholder="请输入联系人及职务"/>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系电话:" prop="tel">
								<el-input v-model="form.tel" placeholder="请输入联系电话" type="number" maxlength="11"/>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row class="form-box-title">
						<div class="form-box-title-img">
							<img src="@/assets/images/xwqyczfw/rzfw/sx.png" />
						</div>
						<div class="form-box-flex">
							授信申请信息
						</div>
					</el-row>
					<el-row>
						<el-col :span="11">
							<el-form-item label="申请贷款金额:" prop="loanMoney">
								<el-input v-model="form.loanMoney" type="number" clearable class="input-width" placeholder="请输入申请贷款金额"/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元</el-col>
						<el-col :span="11" >
							<el-form-item label="贷款期限:" prop="loanTerm">
								<el-tooltip class="item" effect="light" content="贷款期限，12 24 36 三种" placement="right">
								<el-input v-model="form.loanTerm" type="number" clearable class="input-width" placeholder="请输入贷款期限"/>
								</el-tooltip>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">月</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="本行开户信息:" prop="bhkhxx">
								<el-select v-model="form.bhkhxx" size="medium" clearable class="input-width">
								  <el-option
								    v-for="item in bhkhxxOptions"
								    :key="item.dictValue"
								    :label="item.dictLabel"
								    :value="item.dictValue">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="是否已开通我行企业网银:" prop="isktqywy" style="line-height: 1.25rem;">
								<el-radio-group v-model="form.isktqywy">
									<el-radio label="Y">是</el-radio>
									<el-radio label="N">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="还款方式:" prop="hkfs">
								<el-tooltip class="item" effect="light" content="还款方式，等额本息还款法  按月还息，到期一次还本法  按还款计划还款法" placement="right">
								<el-select v-model="form.hkfs" size="medium" clearable class="input-width">
								  <el-option
								    v-for="item in hkfsOptions"
								    :key="item.dictValue"
								    :label="item.dictLabel"
								    :value="item.dictValue">
								  </el-option>
								</el-select></el-tooltip>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="贷款用途" prop="loanUse">
								<el-tooltip class="item" effect="light" content="货物采购 材料采购" placement="right">
								<el-input type="textarea" placeholder="请输入贷款用途" v-model="form.loanUse" :autosize="{ minRows: 5, maxRows: 10}"/>
								</el-tooltip>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row class="form-box-title">
						<div class="form-box-title-img">
							<img src="@/assets/images/xwqyczfw/rzfw/db.png" />
						</div>
						<div class="form-box-flex">
							担保信息
						</div>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="抵押:" prop="dy">
								<el-select v-model="form.dy" size="medium" clearable class="input-width">
								  <el-option
								    v-for="item in dyOptions"
								    :key="item.dictValue"
								    :label="item.dictLabel"
								    :value="item.dictValue">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="保证:" prop="bz">
								<el-select v-model="form.bz" size="medium" clearable class="input-width">
								  <el-option
								    v-for="item in bzOptions"
								    :key="item.dictValue"
								    :label="item.dictLabel"
								    :value="item.dictValue">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="其他担保方式:" prop="isqtdbfs" style="line-height: 1.25rem;">
								<el-radio-group v-model="form.isqtdbfs">
									<el-radio label="Y">是</el-radio>
									<el-radio label="N">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row class="form-box-title">
						<div class="form-box-title-img">
							<img src="@/assets/images/xwqyczfw/rzfw/qt.png" />
						</div>
						<div class="form-box-flex">
							其他服务需求
						</div>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="您及您的企业已使用我行产品情况:" prop="sycpqk">
								<el-select v-model="form.sycpqk" size="medium" clearable class="input-width">
								  <el-option
								    v-for="item in sycpqkOptions"
								    :key="item.dictValue"
								    :label="item.dictLabel"
								    :value="item.dictValue">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="您及您的企业下一步其他金融服务需求:" prop="jrfwxq">
								<el-select v-model="form.jrfwxq" size="medium" clearable class="input-width">
								  <el-option
								    v-for="item in sycpqkOptions"
								    :key="item.dictValue"
								    :label="item.dictLabel"
								    :value="item.dictValue">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item>
					    <el-checkbox v-model="promise"><span style="color:#E92B26">我承诺：我所填写的申请信息真实有效。我单位对填写的内容真实性负责，如有虚假将依法承担相应责任。</span></el-checkbox>
					</el-form-item>
					<el-row>
					    <el-col :span="24"  class="btn">
					        <el-button type="info" @click="submitForm('N')">保 存</el-button>
					        <el-button type="primary" @click="submitForm('Y')">提交并申请</el-button>
					    </el-col>
					</el-row>
				</el-form>
			</div>
        </el-row>

    </div>
</template>

<script>
	import { addRzsqsx, updateRzsqsx, getRzsqsx,getEntInfo} from "@/api/xwqy/rzsqsx";
	export default {
	    name: "xwqyXqsq",
	    data() {
	        return {
				khhylxOptions:[],
				bhkhxxOptions:[],
				hkfsOptions:[],
				dyOptions:[],
				bzOptions:[],
				sycpqkOptions:[],
				promise:false,
				form:{
					entname: undefined,
					uniscid: undefined,
					lerep:undefined,
					khhylx:undefined,
					dom:undefined,
					regist:undefined,
					busscope:undefined,
					operatYear:undefined,
					contactOffice:undefined,
					tel:undefined,
					loanMoney:undefined,
					loanTerm:undefined,
					bhkhxx:undefined,
					isktqywy:'Y',
					hkfs:undefined,
					loanUse:undefined,
					dy:undefined,
					bz:undefined,
					isqtdbfs:'Y',
					sycpqk:undefined,
					jrfwxq:undefined,
					iszc:undefined,
					ywFwjgRecid:undefined,
				},
				rules:{
					entname: [{
						required: true,
						message: '请输入企业名称',
						trigger: 'blur'
					}],
					uniscid: [{
						required: true,
						message: '请输入统一社会信用代码',
						trigger: 'blur'
					}],
					lerep: [{
						required: true,
						message: '请输入法定代表人',
						trigger: 'blur'
					}],
					khhylx:[
					    { required: true, message: '请选择客户行业类型', trigger: 'change' }
					],
					dom: [{
						required: true,
						message: '请输入经营地址',
						trigger: 'blur'
					}],
					regist: [{
						required: true,
						message: '请输入注册资本',
						trigger: 'blur'
					}],
					busscope: [{
						required: true,
						message: '请输入主营业务范围',
						trigger: 'blur'
					}],
					operatYear: [{
						required: true,
						message: '请输入持续经营年限',
						trigger: 'blur'
					}],
					contactOffice: [{
						required: true,
						message: '请输入联系人及职务',
						trigger: 'blur'
					}],
					tel: [{
						required: true,
						message: '请输入联系电话',
						trigger: 'blur'
					}],
					loanMoney: [{
						required: true,
						message: '请输入申请贷款金额',
						trigger: 'blur'
					}],
					loanTerm: [{
						required: true,
						message: '请输入贷款期限',
						trigger: 'blur'
					}],
					bhkhxx:[
					    { required: true, message: '请选择本行开户信息', trigger: 'change' }
					],
					isktqywy:[
					    { required: true, message: '请选择是否已开通我行企业网银', trigger: 'change' }
					],
					hkfs:[
					    { required: true, message: '请选择还款方式', trigger: 'change' }
					],
					loanUse: [{
						required: true,
						message: '请输入贷款用途',
						trigger: 'blur'
					}],
					dy:[
					    { required: true, message: '请选择抵押方式', trigger: 'change' }
					],
					bz:[
					    { required: true, message: '请选择保证方式', trigger: 'change' }
					],
					isqtdbfs:[
					    { required: true, message: '请选择其他担保方式', trigger: 'change' }
					],
					sycpqk:[
					    { required: true, message: '请选择您及您的企业已使用我行产品情况', trigger: 'change' }
					],
					jrfwxq:[
					    { required: true, message: '请选择您及您的企业下一步其他金融服务需求', trigger: 'change' }
					],
				},
				recid: undefined,
				ywFwjgRecid:undefined
			}
		},
		created() {

			this.getDicts("yw_khhylx_type").then(response => {
			    this.khhylxOptions = response.data;
			});
			this.getDicts("yw_bhkhxx_type").then(response => {
			    this.bhkhxxOptions = response.data;
			});
			this.getDicts("yw_hkfs_type").then(response => {
			    this.hkfsOptions = response.data;
			});
			this.getDicts("yw_dy_type").then(response => {
			    this.dyOptions = response.data;
			});
			this.getDicts("yw_bz_type").then(response => {
			    this.bzOptions = response.data;
			});
			this.getDicts("yw_sycpqk_type").then(response => {
			    this.sycpqkOptions = response.data;
			});
			let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			if(ssessionLoginUser != null && ssessionLoginUser != undefined){
				this.loginUser = ssessionLoginUser.user;
				this.form.entname= this.loginUser.corname;
				this.form.uniscid = this.loginUser.cornumber;
				this.form.ywFwjgRecid = this.loginUser.ywFwjgRecid;
				//请求获取一企一档内容
				getEntInfo(this.form.ywFwjgRecid).then(response => {
					this.form.lerep = response.lerep;
					for(let i=0;i<this.khhylxOptions.length;i++){
						if(this.khhylxOptions[i].dictLabel===response.industryphy){
							this.form.khhylx = this.khhylxOptions[i].dictValue;
							break;
						}else{
							this.form.khhylx = this.khhylxOptions[i].dictValue;
						}
					}
					this.form.busscope = response.busscope;
					this.form.dom = response.dom;
					this.form.regist = response.regcap;
					this.form.contactOffice = response.llr;
					this.form.tel = response.llrtel;
				});
				//----【】需要修改为recid
				this.ywFwjgRecid = this.loginUser.ywFwjgRecid;
			}
			
			this.recid = this.$route.params && this.$route.params.recid;
			// console.log(this.recid)
			this.getDetail();
		},
		methods:{
			checkPhone(){
				let mobile = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/ // 最新16手机正则
				let value = this.form.tel;
				if (value !== null && value !==undefined && value !==''){
					if(!mobile.test(value)){
						this.msgWarning("您输入的联系电话格式不正确，请重新输入！");
						return false;
					}else{
						return true;
					}
				}else{
					return true;
				}
			},
			getDetail(){
				if (this.recid != null && this.recid != undefined) {
					this.reset();
					const recid = this.recid;
					getRzsqsx(recid).then(response => {
						// console.log(response)
						this.form = response.data;
					});
				}
			},
			// 表单重置
			reset() {
				this.form = {
					recid: undefined,
					entname: undefined,
					uniscid: undefined,
					lerep: undefined,
					khhylx: undefined,
					dom: undefined,
					regist: undefined,
					busscope: undefined,
					operatYear: undefined,
					contactOffice: undefined,
					tel: undefined,
					loanMoney: undefined,
					loanTerm: undefined,
					bhkhxx: undefined,
					isktqywy: undefined,
					hkfs: undefined,
					loanUse: undefined,
					dy: undefined,
					bz: undefined,
					isqtdbfs: undefined,
					jrfwxq: undefined,
					sycpqk: undefined,
					status: undefined,
					isSubmit: undefined,
					createby: undefined,
					createtime: undefined,
					updateby: undefined,
					updatetime: undefined,
					opIdea:undefined,
					ywAuditStatus: undefined,
				};
				this.resetForm("form");
			},
			toPage(url){
			    this.$router.push({
			        path: url,
			    });
			    this.$store.commit('SET_MAININDEX', url);
			},
			submitForm(status){
				if (this.utils.isLoginTimeout()) {
					this.form.ywSaveStatus=status;
					this.$refs["form"].validate(valid => {
					    if (valid && this.checkPhone()) {
					        if (this.promise) {
								this.form.iszc = status
								this.form.isSubmit = status;
					            this.$confirm(`是否${status =='Y' ?"提交" :"保存"}?`, '提示', {
					                confirmButtonText: '确定',
					                cancelButtonText: '取消',
					                type: 'warning'
					            }).then(() => {
					                this.saveForm();
					            })
					        } else {
					            this.msgWarning("请选择承诺");
					        }
					    }
					})
				} else {
					this.$confirm('登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
			},
			/** 提交按钮 */
			submitFormCheckLoginAfter(status) {
				this.$refs["form"].validate(valid => {
					if(valid){
						if(this.promise){
							this.form.iszc = status
							if ('Y' == status) {
								this.form.ywSaveStatus='Y';
								this.$confirm('是否提交并申请？', '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									this.saveForm();
								})
							} else {
								this.form.isSubmit = status;
								this.$confirm('是否只提交并不申请？', '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									this.saveForm();
								})
							}
						}else{
							this.msgError("请选择承诺");
						}
					}
				})
			},
			saveForm(){
				// console.log("this.form",this.form);
				if (this.form.recid != undefined) {
					updateRzsqsx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("修改成功");
							setTimeout(function(){
								window.opener=null;
								window.open('','_self');
								window.close();
							},1000)
						} else {
							this.msgError(response.msg);
						}
					});
				} else {
					addRzsqsx(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("成功");
							this.toPage('/main/xwqyczfw/rzfw');
							this.$router.back();
						} else {
							this.msgError(response.msg);
						}
					});
				}
			},
		}
	}
</script>

<style scoped="scoped">
	.app-container{
	    padding:0px 15px 20px;
	    background-color: #ffffff;
	}
	.navigation{
	    padding:20px 15px;
	    line-height: 20px;
	    height: 60px;
	    background-color: #F5F5F5;
	    margin-bottom: 15px;
	}
	.content{
	    border: 1px solid #cccccc;
	    padding:20px 60px;
	}
	.box-title{
		color: #4A8DEC;
		font-size: 1.25rem;
		font-weight: bold;
		text-align: left;
	}
	.el-checkbox__label{
		color: red;
	}
	.form-div .form-box-title {
		display: flex;
		height: 1.5625rem;
		line-height: 1.5625rem;
		font-size: 1.0625rem;
		/* padding-bottom: 0.4375rem; */
	}
	
	.form-div .form-box-title img {
		width: 1rem;
		height: 1rem;
		/* margin: 0.625rem 0 0.8125rem; */
	}
	
	.form-div .form-box-title .form-box-flex {
		flex: 1;
		padding-left: 0.625rem;
		text-align: left;
	}
	.remarks{
	    text-align: right;
	    color: #999999;
	    font-size: 12px;
		vertical-align:middle;
		line-height: 2.25rem;
	}
	btn{
	    text-align: center;
	}
	.btn .el-button+.el-button{
	    margin-left: 30px;
	}
	/deep/.el-form-item__label {
		padding: 0 50px 0 0;
	}

	/deep/.el-form-item__content {
		text-align: left;
	}
	.input-width{
		width: 19.25rem;
	}
</style>
